import React, { useState, useEffect, useContext } from "react";
import * as func from "../../api/apiHelper";
import * as urls from "../../api/urlHelper";
import ConfirmationPopup from "../deletePopup/deletePopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faPenToSquare,
  faPlus,
  faMobileScreen,
  faSearch,
  faBell,
  faEye,
  faUsers,
  faSlidersH,
  faXmark,
  faDownload,
  faFingerprint,
} from "@fortawesome/free-solid-svg-icons";
import { downloadExport } from "../../api/apiHelper";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AppContext } from "../context/appContext";
import { MSContext } from "../context/matchseekerContext";
import FilterPanel from "../common/FilterPanel";
import FilterChips, { countActive } from "../common/FilterChips";
import { MATCH_SEEKER_FILTERS, buildFlatPayload } from "../../config/filterConfigs";

const STATUS_CLS = {
  ACTIVE: "bg-green-100 text-green-700",
  BLOCKED: "bg-red-100 text-red-600",
  INACTIVE: "bg-gray-100 text-gray-500",
};


const MatchSeekerListing = () => {
  const [filteredSeekers, setFilteredSeekers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteUserData, setDeleteUserData] = useState({});
  const [showDeleteButton, setShowDeleteButton] = useState(true);
  const [updateMobileUserData, setUpdateMobileUserData] = useState(null);
  const [showUpdateMobileNo, setShowUpdateMobileNo] = useState(false);
  const [step, setStep] = useState(1);
  const [otpTokenData, setOtpTokenData] = useState({});
  const [otpMessage, setOtpMessage] = useState("");
  const [otp, setOtp] = useState(null);
  const [disableSendOtpButton, setDisableSendOtpButton] = useState(false);
  const [step1Data, setStep1Data] = useState({ phoneNumber: "", countryCode: "+91", type: "matchseeker" });

  const { matchseekerMasterData } = useContext(AppContext);
  const {
    msSearchTerm: searchTerm,
    setMsSearchTerm: setSearchTerm,
    msFilters: filters,
    setMsFilters: setFilters,
    ContextCurrentPage: currentPage,
    contextSetCurrentPage: setCurrentPage,
    ContextTotalPages: totalPages,
    contextSetTotalPages: setTotalPages,
    Contextlimit: limit,
    ContextReload: reload,
    ContextSetReload: setReload,
  } = useContext(MSContext);

  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();
    const fetchMatchSeekers = async () => {
      setLoading(true);
      const params = { page: currentPage, limit };
      try {
        let apiResponse;
        if (searchTerm) {
          params.query = searchTerm.trim();
          apiResponse = await func.get(urls.SEARCH_MATCHSEEKER_URL, { params, signal: controller.signal });
        } else if (Object.keys(filters).some((key) => filters[key])) {
          const modifiedFilters = buildFlatPayload(filters);
          apiResponse = await func.post(urls.FILTER_MATCHSEEKER_URL, modifiedFilters, { params, signal: controller.signal });
        } else {
          apiResponse = await func.get(urls.GET_ALL_MATCHSEEKERS_URL, { params, signal: controller.signal });
        }
        if (apiResponse?.status === 200) {
          setFilteredSeekers(apiResponse?.data?.matchSeekers || apiResponse?.data?.data || []);
          setTotalPages(apiResponse?.data?.totalPages || 1);
        } else {
          toast.error("Error fetching match seekers");
        }
      } catch (err) {
        if (err?.code === "ERR_CANCELED" || err?.name === "CanceledError") return;
        toast.error("Network error");
      } finally {
        setLoading(false);
      }
    };
    fetchMatchSeekers();
    return () => controller.abort();
  }, [reload, currentPage]);

  const handleSearch = () => { setReload(!reload); setCurrentPage(1); };

  const applyFilters = () => { setReload(!reload); setShowFilter(false); setCurrentPage(1); setSearchTerm(""); };

  const resetFilters = () => {
    setFilters({ fullName: "", emailId: "", religion: "", caste: "", subCaste: "", _accountStatus: "", mobile: "", subscription: "", createdAt: "", updatedAt: "", startDate: "", endDate: "", invited_by: "" });
    setSearchTerm("");
    setReload(!reload);
    setCurrentPage(1);
  };

  const clearFilterKeys = (keys) => {
    const next = { ...filters };
    keys.forEach((k) => { next[k] = ""; });
    setFilters(next);
    setReload(!reload);
    setCurrentPage(1);
  };

  const handleAccept = async () => {
    setShowDeleteButton(false);
    if (filteredSeekers?.length === 1) setCurrentPage(Math.max(1, currentPage - 1));
    try {
      const apiResponse = await func.del(urls.DELETE_MATCHSEEKER_URL + deleteUserData?._id);
      setShowDeleteButton(true);
      if (apiResponse?.status === 200) {
        toast.success("Match Seeker Deleted Successfully");
        setDeleteUserData({});
        setReload(!reload);
        setShowDeletePopup(false);
      } else {
        toast.warn(apiResponse);
      }
    } catch (error) {
      toast.error(error);
      setShowDeleteButton(true);
    }
  };

  const handleSendOtp = async () => {
    setDisableSendOtpButton(true);
    const res = await func.post(urls.VERIFY_USER_URL, step1Data);
    if (res?.status === 200 && res?.statusText === "OK") {
      toast.success(`OTP sent to ${step1Data.phoneNumber}`);
      setOtpTokenData(res.data);
      setOtpMessage(`Enter the OTP sent to: ${step1Data.phoneNumber}`);
      setStep(2);
    } else {
      toast.warn(res);
      setStep(1);
      setOtp(null);
    }
    setDisableSendOtpButton(false);
  };

  const handleUpdateMatchSeeker = async () => {
    const { caste, subCaste, religion, userId } = updateMobileUserData;
    if (!step1Data.phoneNumber.trim() || step1Data.phoneNumber.length < 10) {
      toast.warn("Enter valid mobile number");
      return;
    }
    const apidata = { ...updateMobileUserData, caste: caste?._id, subCaste: subCaste || "", religion: religion?._id, userId: userId?._id, newMobileNo: step1Data.phoneNumber };
    const response = await func.put(urls.EDIT_MATCHSEEKER_URL + updateMobileUserData?._id, apidata);
    if (response?.status === 200 || response?.status === 201) {
      toast.success("Mobile Number Updated Successfully");
      setStep1Data({ phoneNumber: "", countryCode: "+91", type: "matchseeker" });
      setShowUpdateMobileNo(false);
      setReload(!reload);
    } else {
      toast.warn(response);
    }
  };

  const handleVerifyOtp = async () => {
    const res = await func.post(urls.VERIFY_OTP_PHONE, { hashedOtpToken: otpTokenData.hashedOtpToken, otp });
    if ((res?.status === 200 && res?.statusText === "OK") || (res?.status === 201 && res?.statusText === "Created")) {
      toast.success("OTP Verified Successfully");
      handleUpdateMatchSeeker();
    } else {
      toast.warn(res);
    }
    setStep(1);
    setOtp(null);
  };

  const closeMobileModal = () => {
    setShowUpdateMobileNo(false);
    setStep(1);
    setUpdateMobileUserData(null);
    setStep1Data({ phoneNumber: "", countryCode: "+91", type: "matchseeker" });
  };

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
    (p) => p >= currentPage - 2 && p <= currentPage + 2
  );

  return (
    <div className="min-h-screen bg-[linear-gradient(to_left,_#19224B,_#E2B865)] p-6 mt-14 rounded-xl">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <FontAwesomeIcon icon={faUsers} className="text-white text-xl" />
            <div>
              <h1 className="text-2xl font-bold text-white">Match Seekers</h1>
              <p className="text-white/70 text-sm">All registered match seeker accounts</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowFilter(true)}
              className="flex items-center gap-2 px-4 py-2 text-sm bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg transition border border-white/20"
            >
              <FontAwesomeIcon icon={faSlidersH} />
              Filters
              {countActive(MATCH_SEEKER_FILTERS, filters) > 0 && (
                <span className="ml-1 inline-flex items-center justify-center text-[10px] font-bold bg-white text-indigo-700 rounded-full w-5 h-5">
                  {countActive(MATCH_SEEKER_FILTERS, filters)}
                </span>
              )}
            </button>
            <button
              onClick={async () => {
                try {
                  const today = new Date().toISOString().slice(0, 10);
                  await downloadExport('mst-admin/export/match-seekers', {
                    search: searchTerm || undefined,
                    status: filters._accountStatus || undefined,
                  }, `match_seekers_${today}.csv`);
                } catch { toast.error('Export failed'); }
              }}
              className="flex items-center gap-2 px-4 py-2 text-sm bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg transition border border-white/20"
            >
              <FontAwesomeIcon icon={faDownload} />
              Export All
            </button>
            <button
              onClick={() => navigate("/user-management/match-seekers/add")}
              className="flex items-center gap-2 px-4 py-2 text-sm bg-white text-indigo-700 font-semibold rounded-lg hover:bg-indigo-50 transition shadow"
            >
              <FontAwesomeIcon icon={faPlus} />
              Add Match Seeker
            </button>
          </div>
        </div>

        {/* Search */}
        <div className="flex gap-2 mb-4">
          <div className="relative flex-1 max-w-sm">
            <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                if (!e.target.value.trim()) { setCurrentPage(1); setReload(!reload); }
              }}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              maxLength={60}
              placeholder="Search by name, email, mobile..."
              className="w-full pl-9 pr-3 py-2 text-sm bg-white rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-400"
            />
          </div>
          <button
            onClick={handleSearch}
            className="px-4 py-2 text-sm bg-white text-indigo-700 font-semibold rounded-lg hover:bg-indigo-50 transition shadow"
          >
            Search
          </button>
        </div>

        <FilterChips
          config={MATCH_SEEKER_FILTERS}
          filters={filters}
          onClearKeys={clearFilterKeys}
          onClearAll={resetFilters}
        />

        {/* Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  {["#", "Name / Email / Mobile", "Religion", "Caste / Sub-caste", "Created / Updated", "Status", "Actions"].map((h) => (
                    <th key={h} className="px-4 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wide whitespace-nowrap">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  [...Array(8)].map((_, i) => (
                    <tr key={i} className="border-b border-gray-100 animate-pulse">
                      {[...Array(7)].map((_, j) => (
                        <td key={j} className="px-4 py-3"><div className="h-4 bg-gray-200 rounded" /></td>
                      ))}
                    </tr>
                  ))
                ) : filteredSeekers.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="py-16 text-center text-gray-400">
                      <FontAwesomeIcon icon={faUsers} className="text-3xl mb-3 block mx-auto opacity-20" />
                      No match seekers found
                    </td>
                  </tr>
                ) : (
                  filteredSeekers.map((seeker, index) => {
                    const status = seeker.userId?._accountStatus || "INACTIVE";
                    return (
                      <tr key={seeker?._id} className="border-b border-gray-100 hover:bg-gray-50 transition">
                        <td className="px-4 py-3 text-gray-400 text-xs">{(currentPage - 1) * limit + index + 1}</td>
                        <td className="px-4 py-3">
                          <p className="font-medium text-gray-800">{seeker?.fullName || "—"}</p>
                          <p className="text-xs text-gray-400">{seeker?.emailId || ""}</p>
                          <p className="text-xs text-gray-400">{seeker.userId?._phoneNumber || ""}</p>
                        </td>
                        <td className="px-4 py-3 text-gray-600">{seeker.religion?.religion || "—"}</td>
                        <td className="px-4 py-3">
                          <p className="text-gray-700">{seeker.caste?.caste || "—"}</p>
                          <p className="text-xs text-gray-400">{seeker?.subCaste || ""}</p>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">
                          <p>{new Date(seeker.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</p>
                          <p className="text-gray-400">{new Date(seeker.updatedAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</p>
                        </td>
                        <td className="px-4 py-3">
                          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${STATUS_CLS[status] || "bg-gray-100 text-gray-500"}`}>
                            {status}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-1.5">
                            {seeker?.isSubscriptionAvailable && (
                              <ActionBtn
                                icon={faBell}
                                label="Subscription"
                                cls="bg-amber-50 text-amber-600 hover:bg-amber-100"
                                onClick={() => navigate("/user-management/match-seekers/view-subscription-details", { state: { matchseekerId: seeker?._id } })}
                              />
                            )}
                            <ActionBtn
                              icon={faEye}
                              label="View"
                              cls="bg-indigo-50 text-indigo-600 hover:bg-indigo-100"
                              onClick={() => navigate(`/user-management/match-seekers/view/${seeker?._id}`)}
                            />
                            <ActionBtn
                              icon={faFingerprint}
                              label="Deep Dive"
                              cls="bg-violet-50 text-violet-600 hover:bg-violet-100"
                              onClick={() => navigate(`/user-deep-dive/${seeker?._id}`)}
                            />
                            <ActionBtn
                              icon={faPenToSquare}
                              label="Edit"
                              cls="bg-gray-50 text-gray-600 hover:bg-gray-100"
                              onClick={() => navigate(`/user-management/match-seekers/edit/${seeker._id}`)}
                            />
                            <ActionBtn
                              icon={faMobileScreen}
                              label="Mobile"
                              cls="bg-gray-50 text-gray-600 hover:bg-gray-100"
                              onClick={() => { setUpdateMobileUserData(seeker); setShowUpdateMobileNo(true); }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-1 mt-5">
            <PagBtn onClick={() => setCurrentPage(1)} disabled={currentPage === 1} label="«" />
            <PagBtn onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} icon={faChevronLeft} />
            {currentPage > 3 && <span className="px-2 text-white/60">…</span>}
            {pages.map((p) => (
              <button
                key={p}
                onClick={() => setCurrentPage(p)}
                className={`w-8 h-8 rounded-md text-sm font-medium transition ${
                  p === currentPage ? "bg-white text-indigo-700" : "text-white/70 hover:bg-white/10"
                }`}
              >
                {p}
              </button>
            ))}
            {currentPage < totalPages - 2 && <span className="px-2 text-white/60">…</span>}
            <PagBtn onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages} icon={faChevronRight} />
            <PagBtn onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} label="»" />
          </div>
        )}
      </div>

      {/* Delete Confirmation Popup */}
      <ConfirmationPopup
        show={showDeletePopup}
        onClose={() => setShowDeletePopup(false)}
        onCancel={() => setShowDeletePopup(false)}
        onAccept={handleAccept}
        showDeleteButton={showDeleteButton}
        question={<>Are you sure you want to delete <span className="font-bold italic">{deleteUserData?.fullName}</span>?</>}
        title="Delete Confirmation"
        acceptText="Yes, Delete"
        cancelText="Cancel"
      />

      <FilterPanel
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        title="Filter Match Seekers"
        config={MATCH_SEEKER_FILTERS}
        filters={filters}
        onChange={setFilters}
        onApply={applyFilters}
        onReset={resetFilters}
        masterData={matchseekerMasterData}
      />

      {/* Update Mobile Modal */}
      {showUpdateMobileNo && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-800">Update Mobile Number</h3>
              <button onClick={closeMobileModal} className="text-gray-400 hover:text-gray-600 transition">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
            <div className="px-6 py-4 space-y-4">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">New Mobile Number</label>
                <input
                  type="text"
                  value={step1Data.phoneNumber}
                  disabled={step > 1}
                  onChange={(e) => { setStep1Data({ ...step1Data, phoneNumber: e.target.value }); setStep(1); }}
                  onInput={(e) => { let v = e.target.value.replace(/\D/g, "").slice(0, 10); if (/^[0-5]/.test(v)) v = ""; e.target.value = v; }}
                  placeholder="Enter 10-digit mobile number"
                  className="w-full text-sm px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-400 disabled:bg-gray-50"
                />
              </div>
              {step1Data.phoneNumber.length === 10 && step === 1 && (
                <button
                  onClick={handleSendOtp}
                  disabled={disableSendOtpButton}
                  className="w-full py-2 text-sm bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition font-medium disabled:opacity-50"
                >
                  Send OTP
                </button>
              )}
              {step === 2 && (
                <>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">Enter OTP</label>
                    <input
                      type="text"
                      value={otp || ""}
                      onChange={(e) => setOtp(e.target.value)}
                      onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4); }}
                      placeholder="4-digit OTP"
                      className="w-full text-sm px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-400"
                    />
                    {otpMessage && <p className="text-xs text-green-600 mt-1">{otpMessage}</p>}
                  </div>
                  {otp?.length === 4 && (
                    <button
                      onClick={handleVerifyOtp}
                      className="w-full py-2 text-sm bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition font-medium"
                    >
                      Verify OTP
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ActionBtn = ({ icon, label, cls, onClick }) => (
  <div className="group relative">
    <button onClick={onClick} className={`flex items-center justify-center w-7 h-7 rounded-md transition ${cls}`}>
      <FontAwesomeIcon icon={icon} className="text-xs" />
    </button>
    <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:block text-xs bg-gray-800 text-white px-2 py-0.5 rounded shadow-lg whitespace-nowrap z-10">
      {label}
    </span>
  </div>
);

const PagBtn = ({ onClick, disabled, label, icon }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`w-8 h-8 flex items-center justify-center rounded-md text-sm transition ${
      disabled ? "text-white/20 cursor-not-allowed" : "text-white/70 hover:bg-white/10"
    }`}
  >
    {icon ? <FontAwesomeIcon icon={icon} className="text-xs" /> : label}
  </button>
);

export default MatchSeekerListing;
